// Generated by CoffeeScript 2.7.0
var Modal;

import ModalMixin from 'trunks/vue/admin/mixins/modal.js';

// this should be a shared private component, can not create instance directly
export default Modal = {
  name: 'Modal',
  props: {
    backdrop: {
      type: Boolean,
      default: false
    },
    extendClass: {
      type: [String, Array]
    },
    title: {
      type: String
    },
    ensureText: {
      type: String,
      default: '确定'
    },
    size: {
      type: String
    }
  },
  mixins: [ModalMixin],
  template: `<div class="modal"
     :class='[statusClass, extendClass, modalSize]'
     v-animationend.stop='animationEnd'>
  <div class="content" v-animationend.stop ref="content">
    <div class="modal-header">
      <div class="modal-title" v-html='title'></div>
      <div class="closer" @click='close'>
        <i class="slp-times"></i>
      </div>
    </div>
    <slot>
      <p>默认的body</p>
    </slot>
    <slot name='footer'>
      <div class="modal-footer">
        <button class="outlined btn-default" @click='cancel'>取消</button>
        <button @click='ensure'>{{ ensureText }}</button>
      </div>
    </slot>
  </div>
</div>`
};
